import { useId } from 'react';

export const useField = () => {
  const id = useId();
  const fieldId = 'field' + id;
  const inputId = 'field-input' + id;

  const fieldProps = (ref, props) => {
    const rps = {
      id: fieldId,
    };

    const rct = {
      ref,
    };

    return {
      ...rps,
      ...rct,
      ...props,
    };
  };

  const labelProps = (ref, props) => {
    const rps = {
      htmlFor: inputId,
    };

    const rct = {
      ref,
    };

    return {
      ...rps,
      ...rct,
      ...props,
    };
  };

  const inputProps = (ref, props) => {
    const rps = {
      id: inputId,
    };

    const rct = {
      ref,
    };

    return {
      ...rps,
      ...rct,
      ...props,
    };
  };

  return {
    fieldProps,
    labelProps,
    inputProps,
  };
};
